export const CONSENT_CHANGED_EVENT = 'OneTrustGroupsUpdated';

export function onConsentChange(callback: (activeGroups: string) => void): () => void {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const handler = () => {
    callback(window.OnetrustActiveGroups ?? '');
  };

  window.addEventListener(CONSENT_CHANGED_EVENT, handler);

  return () => {
    window.removeEventListener(CONSENT_CHANGED_EVENT, handler);
  };
}
